<template>
  <vx-card title="Customer Deposit">
    <div class="flex flex-row gap-3 mb-6">
      <!-- Filter Section -->
      <div class="flex flex-col w-1/2 gap-4">
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Posting Date</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full whitespace-no-wrap">
            <div class="flex justify-between items-center">
              <date-range-picker
                style="min-height: 40px"
                class="w-full"
                ref="picker"
                opens="center"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :singleDatePicker="false"
                :timePicker="false"
                :timePicker24Hour="false"
                :showWeekNumbers="false"
                :showDropdowns="false"
                :autoApply="true"
                v-model="depositDate"
                :linkedCalendars="true"
              >
                <template v-slot:input="picker">
                  {{ globalDateFormat(picker.startDate) }} -
                  {{ globalDateFormat(picker.endDate) }}
                </template>
              </date-range-picker>
              <vs-button
                class="ml-4"
                color="danger"
                icon-pack="feather"
                icon="icon-x"
                @click="
                  () => {
                    this.depositDate = { startDate: null, endDate: null };
                  }
                "
              ></vs-button>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Deposit Date</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full whitespace-no-wrap">
            <div class="flex justify-between items-center">
              <date-range-picker
                style="min-height: 40px"
                class="w-full"
                ref="picker"
                opens="center"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :singleDatePicker="false"
                :timePicker="false"
                :timePicker24Hour="false"
                :showWeekNumbers="false"
                :showDropdowns="false"
                :autoApply="true"
                v-model="collectDate"
                :linkedCalendars="true"
              >
                <template v-slot:input="picker">
                  {{ globalDateFormat(picker.startDate) }} -
                  {{ globalDateFormat(picker.endDate) }}
                </template>
              </date-range-picker>
              <vs-button
                class="ml-4"
                color="danger"
                icon-pack="feather"
                icon="icon-x"
                @click="
                  () => {
                    this.collectDate = { startDate: null, endDate: null };
                  }
                "
              ></vs-button>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Operating Unit</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full whitespace-no-wrap">
            <operating-unit-filter
              :hide-show-button="true"
              :hide-territory="true"
              :hide-operating-unit-label="true"
              :show-title="false"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Territory</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full whitespace-no-wrap">
            <territory-filter
              :multi-select="true"
              :show-title="false"
              :full="true"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Customer Deposit Code</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full whitespace-no-wrap">
            <div class="flex justify-between items-center">
              <multiselect
                v-model="selectedDepositCodes"
                :options="depositCodeOptions"
                :multiple="true"
                placeholder="Type to search (min. 3 characters)"
                track-by="ID"
                label="Code"
                @search-change="onDepositCodeSearch"
                class="w-full h-full"
                :max-height="130"
                :loading="isLoadingDepositCodes"
                :internal-search="false"
              >
                <template slot="noOptions">
                  <span v-if="searchMinCharsMessage">{{
                    searchMinCharsMessage
                  }}</span>
                  <span v-else>List is empty</span>
                </template>
                <template slot="noResult">
                  <span v-if="searchMinCharsMessage">{{
                    searchMinCharsMessage
                  }}</span>
                  <span v-else>No results found</span>
                </template>
              </multiselect>
              <vs-button
                class="ml-4"
                color="danger"
                icon-pack="feather"
                icon="icon-x"
                @click="
                  () => {
                    this.selectedDepositCodes = [];
                  }
                "
              ></vs-button>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full flex items-center"></div>
          <div class="vx-col sm:w-1/3 w-full whitespace-no-wrap">
            <vs-button color="primary" @click="handleShow"> Show </vs-button>
          </div>
          <div class="vx-col sm:w-1/3 w-full"></div>
        </div>
      </div>
    </div>

    <vs-button class="mb-2 mr-2" @click="handleOpenForm">Create</vs-button>
    <vs-button class="mb-2" @click="handleExport">Export</vs-button>
    <div class="vx-row mb-12">
      <div
        v-bind:class="[
          detail ? detailShow + 'md:w-1/4 w-full mb-base' : '',
          detailHide,
        ]"
      >
        <vs-tabs :color="colorx" v-model="activeTab">
          <!-- <vs-tab @click="colorx = 'danger'" label="Proposal Approved">
            <div class="con-tab-ejemplo">
              <proposal />
            </div>
          </vs-tab> -->
          <vs-tab @click="handleTabChange('draft', 'danger')" label="Draft">
            <div class="con-tab-ejemplo">
              <open
                ref="open"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <vs-tab
            @click="handleTabChange('execution', 'warning')"
            label="Execution"
          >
            <div class="con-tab-ejemplo">
              <execution
                ref="execution"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <!-- <vs-tab @click="colorx = 'success'" label="Mapping">
            <div class="con-tab-ejemplo">
              <mapping :collectionDate="collectDate" :depositDate="depositDate" />
            </div>
          </vs-tab> -->
          <vs-tab
            @click="handleTabChange('waiting_reconcile', 'primary')"
            label="Waiting Reconcile"
          >
            <div class="con-tab-ejemplo">
              <waiting
                ref="waiting"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <vs-tab
            @click="handleTabChange('reconciled', 'primary')"
            label="Reconciled"
          >
            <div class="con-tab-ejemplo">
              <recon
                ref="recon"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <!-- <vs-tab @click="colorx = 'primary'" label="Failed">
            <div class="con-tab-ejemplo">
              <failed :collectionDate="collectDate" :depositDate="depositDate" />
            </div>
          </vs-tab> -->
          <vs-tab
            @click="handleTabChange('canceled', 'primary')"
            label="Canceled"
          >
            <div class="con-tab-ejemplo">
              <cancel
                ref="cancel"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <!-- <vs-tab @click="colorx = 'primary'"  label="Reverse">
            <div class="con-tab-ejemplo">
              <reverse :collectionDate="collectDate" :depositDate="depositDate" />
            </div>
          </vs-tab> -->
          <vs-tab
            @click="handleTabChange('by_customer', 'primary')"
            label="By Customer"
          >
            <div class="con-tab-ejemplo">
              <by-customer
                ref="byCustomer"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <vs-tab
            @click="handleTabChange('waiting_reverse', 'primary')"
            label="Waiting Reverse"
          >
            <div class="con-tab-ejemplo">
              <waiting-reverse
                ref="waitingReverse"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <vs-tab
            @click="handleTabChange('reversed', 'primary')"
            label="Reversed"
          >
            <div class="con-tab-ejemplo">
              <reverse
                ref="reverse"
                :collectionDate="collectDate"
                :depositDate="depositDate"
                :reloadTrigger="reloadTrigger"
                :customerDepositCodes="customerDepositCodes"
                :key="componentKey"
              />
            </div>
          </vs-tab>
          <!-- <vs-tab @click="colorx = 'primary'" label="Rejected">
            <div class="con-tab-ejemplo">
              <rejected
                :collectionDate="collectDate"
                :depositDate="depositDate"
              />
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
      <transition name="detail-fade">
        <div
          v-if="detail"
          v-bind:class="[
            detail ? detailShow + 'md:w-3/4 w-full mb-base' : '',
            detailHide,
          ]"
        >
          <vs-row>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                class="ml-auto"
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <vs-col
              class="vertical-divider"
              vs-offset="0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="1"
            >
              <vs-button
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
              ></vs-button>
            </vs-col>
            <!-- form component -->
            <create @close="handleClose" />
          </vs-row>
        </div>
      </transition>
    </div>
  </vx-card>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import * as XLSX from "xlsx";
import Multiselect from "vue-multiselect";
import debounce from "debounce";
import territoryFilter from "@/components/operatingUnitFilter/territoryFilter.vue";
import operatingUnitFilter from "@/components/operatingUnitFilter/operatingUnitFilter.vue";

import open from "./open/open.vue";
import byCustomer from "./show_by_customer/index.vue";
import execution from "./execution/execution.vue";
import cancel from "./cancel/cancel.vue";
import mapping from "./mapping/mapping.vue";
import waiting from "./waiting_recon/waiting.vue";
import recon from "./recon/recon.vue";
import failed from "./failed/failed.vue";
import create from "./form-create.vue";
import reverse from "./reverse/reverse.vue";
import rejected from "./rejected/index.vue";
import watingReverse from "./waiting_reverse/index.vue";

export default {
  components: {
    open,
    create,
    execution,
    cancel,
    mapping,
    recon,
    waiting,
    failed,
    byCustomer,
    reverse,
    DateRangePicker,
    rejected,
    "waiting-reverse": watingReverse,
    "territory-filter": territoryFilter,
    "operating-unit-filter": operatingUnitFilter,
    Multiselect,
  },
  data() {
    return {
      detailShow: "core vx-col ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      colorx: "red",
      dn_id: "",
      dn_code: "",
      cn_number: "",
      cn_date: "",
      tr_number: "",
      tr_date: "",
      componentKey: 0,
      postingDate: {},
      depositDate: {
        startDate: null,
        endDate: null,
      },
      collectDate: {
        startDate: null,
        endDate: null,
      },
      methods: ["", "Cash", "Giro", "Cheque", "Transfer"],
      status: [
        "Draft",
        "Execution",
        "",
        "Waiting Reconcile",
        "Canceled",
        "Reconciled",
        "",
        "",
        "Reversed",
      ],
      selectedDepositCodes: [],
      customerDepositCodes: [],
      depositCodeOptions: [],
      debounceFunction: null,
      reloadTrigger: 0,
      activeTab: 0,
      currentTabStatus: null,
      isLoadingDepositCodes: false,
      searchMinCharsMessage: "",
    };
  },
  mounted() {
    this.currentTabStatus = 0; // Draft
    this.getDepositCodes("");
  },
  methods: {
    handleTabChange(tabName, color) {
      this.colorx = color;

      // Map tab names to status codes
      const statusMap = {
        draft: 0,
        execution: 1,
        waiting_reconcile: 3,
        reconciled: 5,
        canceled: 4,
        by_customer: null, // By Customer tidak memiliki status spesifik
        waiting_reverse: 6,
        reversed: 8,
      };

      const newStatus = statusMap[tabName];

      // Hanya reset dan fetch ulang jika status berubah
      if (this.currentTabStatus !== newStatus) {
        // Update current status
        this.currentTabStatus = newStatus;

        // Fetch customer deposit codes berdasarkan status tab (hanya update options, tidak reset selection)
        this.getDepositCodesByStatus(newStatus);
      }
    },
    async getDepositCodesByStatus(status) {
      try {
        this.isLoadingDepositCodes = true;
        const params = {
          type: 2,
          search: "",
          length: 10,
          order: "id",
          sort: "desc",
        };

        // Tambahkan status ke params jika bukan null (untuk By Customer)
        if (status !== null) {
          params.status = status;
        }

        const response = await this.$http.get("/api/v1/cash-bank/data-table", {
          params: params,
        });
        this.depositCodeOptions = response.data.cashBank;
      } catch (err) {
        console.log(err);
        this.$vs.notify({
          title: "Error",
          text: "Failed to load deposit codes",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      } finally {
        this.isLoadingDepositCodes = false;
      }
    },
    onDepositCodeSearch(search) {
      if (this.debounceFunction) {
        this.debounceFunction.clear();
      }

      search = search.trim();

      // Reset message
      this.searchMinCharsMessage = "";

      // Validasi minimal 3 karakter atau kosong untuk load semua
      if (search.length > 0 && search.length < 3) {
        // Jika kurang dari 3 karakter, kosongkan options dan tampilkan pesan
        this.depositCodeOptions = [];
        this.searchMinCharsMessage =
          "Please type at least 3 characters to search";
        this.isLoadingDepositCodes = false;
        return;
      }

      // Set loading state
      this.isLoadingDepositCodes = true;

      // Debounce 3 detik untuk menghindari hit API berulang kali
      this.debounceFunction = debounce(() => {
        this.getDepositCodes(search);
      }, 1500);

      this.debounceFunction();
    },
    async getDepositCodes(search) {
      try {
        this.isLoadingDepositCodes = true;
        const params = {
          type: 2,
          search: search,
          length: 10,
          order: "id",
          sort: "desc",
        };

        // Tambahkan status jika currentTabStatus bukan null
        if (this.currentTabStatus !== null) {
          params.status = this.currentTabStatus;
        }

        const response = await this.$http.get("/api/v1/cash-bank/data-table", {
          params: params,
        });
        this.depositCodeOptions = response.data.cashBank;
      } catch (err) {
        console.log(err);
        this.$vs.notify({
          title: "Error",
          text: "Failed to load deposit codes",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
      } finally {
        this.isLoadingDepositCodes = false;
      }
    },
    handleShow() {
      this.customerDepositCodes = this.selectedDepositCodes.map(
        (item) => item.Code
      );

      // Trigger reload untuk semua tab dengan filter yang dipilih
      this.reloadTrigger++;

      // Wait for next tick to ensure components are re-rendered with new key
      this.$nextTick(() => {
        // Call triggerLoad on all tab components that have been rendered
        const refs = [
          "open",
          "execution",
          "waiting",
          "recon",
          "cancel",
          "byCustomer",
          "waitingReverse",
          "reverse",
        ];
        refs.forEach((refName) => {
          if (this.$refs[refName] && this.$refs[refName].triggerLoad) {
            this.$refs[refName].triggerLoad();
          }
        });
      });
    },
    handleClose() {
      this.detail = false;
      this.componentKey += 1;
      this.$refs.open.closeDetail();
    },
    handleOpenForm() {
      this.detail = true;
      this.status_detail = "form-create";
    },
    handleExport() {
      if (
        this.depositDate.startDate == null &&
        this.collectDate.startDate == null
      ) {
        this.$vs.notify({
          title: "Error",
          text: "Date cannot be blank",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });

        return;
      }
      this.$vs.loading();
      let param = {
        start_collect_date: this.collectDate.startDate
          ? moment(this.collectDate.startDate).format("YYYY-MM-DD")
          : null,
        end_collect_date: this.collectDate.endDate
          ? moment(this.collectDate.endDate).format("YYYY-MM-DD")
          : null,
        start_deposit_date: this.depositDate.startDate
          ? moment(this.depositDate.startDate).format("YYYY-MM-DD")
          : null,
        end_deposit_date: this.depositDate.endDate
          ? moment(this.depositDate.endDate).format("YYYY-MM-DD")
          : null,
      };

      console.log("jalan");
      this.$http
        .get(`/api/v1/cash-bank/export-data`, {
          params: param,
        })
        .then((r) => {
          this.$vs.loading.close();
          if (r.code == 200) {
            console.log("data export", r.data);

            this.$vs.loading.close();
            const data = r.data.cashBank;
            console.log(data);
            const wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet([]);

            // if (!ws["!merges"]) ws["!merges"] = [];
            // ws["!merges"].push(XLSX.utils.decode_range("A1:B2"));
            // if (!ws["!cols"]) ws["!cols"] = [];

            // /* create column metadata object if it does not exist */
            // for (let COL_INDEX = 0; COL_INDEX < 7; COL_INDEX++) {
            //   if (!ws["!cols"][COL_INDEX]) {
            //     ws["!cols"][COL_INDEX] = { wpx: 150 };
            //   }
            // }

            // Set the range of the worksheet
            // ws["!ref"] = "A1:C4";
            // XLSX.utils.sheet_add_aoa(ws, [["Customer Deposit"]], {
            //   origin: "A1",
            // });
            // // Set raw text in a cell
            // XLSX.utils.sheet_add_aoa(ws, [["Customer Name : "]], {
            //   origin: "A4",
            // });

            // XLSX.utils.sheet_add_aoa(ws, [[this.selectedData.PersonName]], {
            //   origin: "B4",
            // });

            const header = [
              "Code",
              "Bank",
              "Deposit Value",
              "Method",
              "Deposit Number",
              "Customer",
              "Posting Date",
              "Deposit Date",
              "Status",
              "Source Transaction",
            ];

            // XLSX.utils.sheet_add_aoa(
            //   ws,
            //   header.map((v) => [v]), // Add an array of arrays to the worksheet
            //   { origin: "A6" }
            // );

            XLSX.utils.sheet_add_aoa(ws, [header], {
              origin: "A1",
            });

            for (let i = 0; i < data.length; i++) {
              const row = [
                data[i].Code,
                data[i].Method != 1
                  ? data[i].BankName +
                    " - " +
                    data[i].BankBranchName +
                    " (" +
                    data[i].AccountNumber +
                    ") "
                  : "",
                this.priceFormat(data[i].DepositValue),
                this.methods[data[i].Method],
                data[i].DepositNumber,
                "(" + data[i].CustomerCode + ") " + data[i].CustomerName,
                this.globalDateFormat(data[i].PostingDate),
                this.globalDateFormat(data[i].DepositDate),
                this.status[data[i].Status],
                data[i].SourceTransaction,
              ];
              XLSX.utils.sheet_add_aoa(ws, [row], {
                origin: `A${2 + i}`,
              });
            }

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(wb, ws, "Customer Deposit");

            // Generate and download the Excel file
            // XLSX.writeFile(wb, "example.xlsx");

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

            // Function to convert the binary string to an ArrayBuffer

            // Create a Blob from the ArrayBuffer
            const blob = new Blob([this.s2ab(wbout)], {
              type: "application/octet-stream",
            });

            // Create a link element
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "";
            if (
              this.collectDate.startDate != null &&
              this.depositDate.startDate != null
            ) {
              link.download = `Customer Deposit - ${moment(
                this.collectDate.startDate
              ).format("YYYY-MM-DD")} - ${moment(
                this.collectDate.endDate
              ).format("YYYY-MM-DD")}.xlsx`;
            } else {
              link.download = `Customer Deposit - ${moment(
                this.depositDate.startDate
              ).format("YYYY-MM-DD")} - ${moment(
                this.depositDate.endDate
              ).format("YYYY-MM-DD")}.xlsx`;
            }

            // Append the link to the document body
            document.body.appendChild(link);

            // Programmatically click the link to trigger the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to load payment",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
        });
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },
  },
};
</script>
<style>
.core-enter-active {
  transition: all 0.3s ease;
}

.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
    .core-leave-to

    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

.highlight > td {
  background-color: #d0cdf0;
}

.con-vs-checkbox {
  margin-left: auto;
  margin-right: auto;
}
</style>
